import React, { useCallback } from "react";
import { Button, FormControl, Grid, TextField, MenuItem } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { Formik } from "formik";
import { floorSchema, useStyleFormAssignRoom } from "../helpers/AssignBuildEvtOption";
import SelectDropOtions from "../../../../components/SelectDropOtions";

const FormFloor = ({ onSubmit = () => {}, initialFormValues = {}, isCreateForm = true, buildingOption = [] }) => {
    const classes = useStyleFormAssignRoom();

    // select building
    const handleSelectBuilding = useCallback(async (values, setFieldValue) => {
        await setFieldValue("buildingId", values);
    }, []);

    // select permission floor
    const handleSelectPermissionFloor = useCallback(async (values, setFieldValue) => {
        await setFieldValue("permission_floor", values);
    }, []);

    return (
        <Formik initialValues={initialFormValues} validationSchema={floorSchema} onSubmit={onSubmit}>
            {({ handleChange, handleSubmit, setFieldValue, values, errors }) => (
                <Grid container spacing={4} className="px-5">
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    กรุณาเลือกสิทธิ <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <SelectDropOtions
                                    containerClass={`${classes.border} ${classes.select}`}
                                    options={[
                                        { id: "0", title: "สิทธิประกันสังคม" },
                                        { id: "1", title: "สิทธิทั่วไป" },
                                    ]}
                                    placeholder="Select..."
                                    value={values?.permission_floor}
                                    onChange={val => handleSelectPermissionFloor(val, setFieldValue)}
                                    error={Boolean(errors?.permission_floor)}
                                    helperText={errors?.permission_floor}
                                    renderOption={row => (
                                        <MenuItem value={row?.id} key={row?.id + "_b"}>
                                            {row?.title}
                                        </MenuItem>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    เลือกอาคาร <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <SelectDropOtions
                                    containerClass={`${classes.border} ${classes.select}`}
                                    options={buildingOption}
                                    placeholder="Select Build..."
                                    value={values?.buildingId}
                                    onChange={val => handleSelectBuilding(val, setFieldValue)}
                                    error={Boolean(errors?.buildingId)}
                                    helperText={errors?.buildingId}
                                    renderOption={row => (
                                        <MenuItem value={row?.buildingId} key={row?.buildingId + "_b"}>
                                            {row?.name}
                                        </MenuItem>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    สร้างชั้น <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <FormControl className="t-form-group-custom w-100">
                                    <TextField
                                        className={`h-100 ${classes.input}`}
                                        InputProps={{
                                            endAdornment: <Edit />,
                                        }}
                                        fullWidth
                                        size="small"
                                        type="text"
                                        name="floorName"
                                        label="สร้างชั้น"
                                        variant="outlined"
                                        value={values?.floorName}
                                        onChange={handleChange}
                                        error={Boolean(errors?.floorName)}
                                        helperText={errors?.floorName}
                                        FormHelperTextProps={{
                                            className: "text-danger position-absolute",
                                            style: { bottom: -25, left: -12 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    รหัสพื้นที่ <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <FormControl className="t-form-group-custom w-100">
                                    <TextField
                                        className={`h-100 ${classes.input}`}
                                        InputProps={{
                                            endAdornment: <Edit />,
                                        }}
                                        fullWidth
                                        size="small"
                                        type="text"
                                        name="locationCode"
                                        label="รหัสพื้นที่"
                                        variant="outlined"
                                        value={values?.locationCode}
                                        onChange={handleChange}
                                        error={Boolean(errors?.locationCode)}
                                        helperText={errors?.locationCode}
                                        FormHelperTextProps={{
                                            className: "text-danger position-absolute",
                                            style: { bottom: -25, left: -12 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    ชื่อพื้นที่ <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <FormControl className="t-form-group-custom w-100">
                                    <TextField
                                        className={`h-100 ${classes.input}`}
                                        InputProps={{
                                            endAdornment: <Edit />,
                                        }}
                                        fullWidth
                                        size="small"
                                        type="text"
                                        name="locationName"
                                        label="ชื่อพื้นที่"
                                        variant="outlined"
                                        value={values?.locationName}
                                        onChange={handleChange}
                                        error={Boolean(errors?.locationName)}
                                        helperText={errors?.locationName}
                                        FormHelperTextProps={{
                                            className: "text-danger position-absolute",
                                            style: { bottom: -25, left: -12 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 2 : 12} lg={isCreateForm ? 1 : 12}>
                        <Grid className="align-items-center justify-content-center h-100">
                            <Grid item xs={12} className="h-100">
                                <Button onClick={handleSubmit} className="t-btn-primary w-100 h-100">
                                    {isCreateForm ? "Add" : "Edit"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Formik>
    );
};

export default FormFloor;
